// extracted by mini-css-extract-plugin
export default {"operationTypesContainer":"style_operationTypesContainer__WJqYz","taxAccordionTab":"style_taxAccordionTab__3cKFM"};